const customerReady = new Promise(resolve => {
  if (window.CF?.customerReady) {
    window.CF.customerReady(resolve);
    return;
  }

  document.addEventListener('cf:customer_ready', resolve);
});

export default customerReady;
